import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import PurchaseModal from "../PurchaseModal"
import "./Login.scss"

const Login = ({ redirectTo = "/book" }) => {
  const history = useHistory()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [showPurchaseModal, setShowPurchaseModal] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    try {
      const response = await fetch(process.env.REACT_APP_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
          query: `
            mutation($email: String!, $password: String!) {
              loginUser(email: $email, password: $password)
            }
          `,
          variables: { email, password }
        })
      })

      const data = await response.json()

      if (data.errors) {
        // Show user-friendly error message, hide technical details
        const errorMessage = data.errors[0].message
        if (errorMessage.includes("password") || errorMessage.includes("credentials") || errorMessage.includes("Invalid")) {
          setError("Incorrect email or password. Please try again.")
        } else {
          setError("Login failed. Please try again.")
        }
        console.error("Login error:", data.errors)
      } else if (data.data?.loginUser !== undefined && data.data?.loginUser !== null) {
        // Successful login: backend should return a numeric user ID.
        const parsedUserId = Number.parseInt(data.data.loginUser, 10)

        if (!Number.isInteger(parsedUserId) || parsedUserId <= 0) {
          setError("Login failed. Please try again.")
          console.error("Unexpected loginUser mutation response:", data.data.loginUser)
          return
        }

        localStorage.setItem("userId", String(parsedUserId))
        history.push(redirectTo)
      } else {
        setError("Login failed. Please check your credentials.")
      }
    } catch (err) {
      setError("An error occurred. Please try again.")
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <article className="login-page">
      <section className="login-wrapper">

        <div className="page-header center pad">
          <h1>Sign In to Access Book</h1>
          <p className="margin-top subheader">You need to purchase access to this content.</p>
        </div>

        <div className="max-width pad pad-lg">
          <div className="login-form-wrapper">
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Enter your email"
                />
              </div>

              <div className="form-row">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Enter your password"
                />
              </div>

              {error && (
                <div className="login-error">
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="button defaultRed"
              >
                {loading ? "Signing in..." : "Sign In"}
              </button>
            </form>

            <div className="login-footer">
              <p className="footer-text">Don't have an account?</p>
              <button
                type="button"
                onClick={() => setShowPurchaseModal(true)}
                className="purchase-link"
              >
                Purchase Book Access
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Purchase Modal */}
      <PurchaseModal
        isOpen={showPurchaseModal}
        onClose={() => setShowPurchaseModal(false)}
      />
    </article>
  )
}

export default Login

